import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class CustomCookieService {
  private COOKIES_CONSENT_COOKIE_NAME = 'cookie_consent';
  private MANAGER_REDIRECT_URL_COOKIE_NAME = 'manager_redirect_url';

  constructor(private cookies: CookieService) {}

  getConsent(): string {
    return this.cookies.get(this.COOKIES_CONSENT_COOKIE_NAME);
  }

  isConsentUpToDate(cookiesUpdateDate: any): boolean {
    if (cookiesUpdateDate) {
      const cookiesDate = moment(cookiesUpdateDate);
      const lastCookiesApproval = this.getConsent();
      const lastCookiesApprovalDate = moment(lastCookiesApproval);

      if (cookiesDate.isBefore(lastCookiesApprovalDate)) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  grantConsent(): void {
    this.cookies.set(this.COOKIES_CONSENT_COOKIE_NAME, moment().toString(), {
      expires: 365,
      path: '/',
    });
  }

  denyConsent(): void {
    this.cookies.set(this.COOKIES_CONSENT_COOKIE_NAME, 'false', {
      expires: 365,
      path: '/',
    });
  }

  deleteAllExceptConsentAndManagerUrl(): void {
    const cookies = document.cookie.split(';');
    cookies.forEach((cookie) => {
      const cookieName = cookie.split('=')[0].trim();
      if ((cookieName !== this.COOKIES_CONSENT_COOKIE_NAME) && (cookieName !== this.MANAGER_REDIRECT_URL_COOKIE_NAME)) {
        this.cookies.delete(cookieName);
      }
    });
  }

  revokeConsent(): void {
    this.cookies.deleteAll();
  }
}
